// extracted by mini-css-extract-plugin
export default {"menu-header":"container_menu-header__qE9On","menu":"container_menu__5JznR"};